import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import W from '../styled/Wrapper';
import H from '../styled/Heading';
import RichText from './RichText';

import Video from './Video';

import ImageItem from '../shared/ImageItem';

const Wrapper = styled(W)`
  display: flex;
  padding-bottom: 63px;

  @media only screen and (max-width: 810px) {
    flex-direction: column;
    padding-bottom: 14px;
  }
`;

const ColWrapper = styled.div`
  width: 50%;
  order: ${({ left }) => (left ? -1 : 'auto')};
  align-self: center;

  @media only screen and (max-width: 810px) {
    width: 100%;
    order: auto;
  }

  &:first-of-type {
    padding-right: ${({ left }) => (left ? '30px' : '0')};
    padding-left: ${({ left }) => (!left ? '30px' : '0')};

    @media only screen and (max-width: 810px) {
      padding-right: 0;
      padding-left: 0;
    }
  }
`;

const LongParagraph = styled.div`
  padding-top: 75px;
  padding-bottom: 75px;
  max-width: 566px;
  margin: 0 auto;

  @media only screen and (max-width: 810px) {
    max-width: 100%;
    padding-top: 0;
    padding-bottom: 15px;
  }
`;

const AssetWrapper = styled.div`
  margin: 0 auto 100px;
  height: ${({ vid, vidPortrait }) => (vid && vidPortrait ? '75vh' : 'auto')};
  width: ${({ vid, portrait, portraitRatio }) =>
    vid ? '100%' : portrait ? (portraitRatio > 1.25 ? '50%' : '65%') : '100%'};
  overflow: hidden;
  object-fit: contain;

  & > div {
    height: ${({ vid }) => (vid ? '100%' : 'auto')};
  }

  img,
  video {
    object-fit: contain !important;
    height: 100%;
  }

  img:first-of-type {
    object-fit: cover !important;
  }

  .graphcms-image-wrapper,
  .graphcms-image-outer-wrapper {
    object-fit: contain;
    height: 100%;
  }

  @media only screen and (max-width: 810px) {
    margin: 0 auto 10px;
    width: 100%;
  }
`;

const TextWrapper = styled.div`
  width: 85%;
  max-width: 565px;
  margin: 0 auto;

  @media only screen and (max-width: 810px) {
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
`;

const Heading = styled(H)`
  margin-bottom: 20px;

  @media only screen and (max-width: 810px) {
    margin-bottom: 10px;
    font-size: 36px;
    line-height: 43px;
  }
`;

const Paragraph = styled.div``;

const TextImgText = ({ data, locs }) => {
  const [vidPortrait, setVidPortrait] = useState(false);
  const el = useRef(null);

  useEffect(() => {
    if (el.current) {
      const vid = el.current.querySelector('video');

      if (vid)
        vid.addEventListener('canplay', () => {
          if (vid.offsetHeight / vid.offsetWidth >= 1) {
            setVidPortrait(true);
          }
        });

      return () => {
        if (vid)
          vid.removeEventListener('canplay', () => {
            if (vid.offsetHeight / vid.offsetWidth >= 1) {
              setVidPortrait(true);
            }
          });
      };
    }
  }, []);

  return (
    <Wrapper>
      <ColWrapper left={data.imageOnTheRight}>
        {data.longText && (
          <LongParagraph>
            <RichText content={data.longText.raw} />
          </LongParagraph>
        )}
      </ColWrapper>

      <ColWrapper left={!data.imageOnTheRight} ref={el}>
        {locs
          ? locs.imageItem && (
              <AssetWrapper
                portrait={
                  locs.imageItem.image &&
                  locs.imageItem.image.height / locs.imageItem.image.width >= 1
                }
                portraitRatio={
                  locs.imageItem.image &&
                  locs.imageItem.image.height / locs.imageItem.image.width
                }
                vid={locs.imageItem.videoUrl}
                vidPortrait={vidPortrait}
              >
                {locs.imageItem.videoUrl ? (
                  <Video
                    loop={locs.imageItem.loop}
                    loopWithSound={locs.imageItem.loopWithSound}
                    video={locs.imageItem.videoUrl}
                    poster={locs.imageItem.image}
                  />
                ) : (
                  <ImageItem image={locs.imageItem.image} />
                )}
              </AssetWrapper>
            )
          : data.imageItem && (
              <AssetWrapper
                portrait={
                  data.imageItem.image &&
                  data.imageItem.image.height / data.imageItem.image.width >= 1
                }
                portraitRatio={
                  data.imageItem.image &&
                  data.imageItem.image.height / data.imageItem.image.width
                }
                vid={data.imageItem.videoUrl}
                vidPortrait={vidPortrait}
              >
                {data.imageItem.videoUrl ? (
                  <Video
                    loop={data.imageItem.loop}
                    video={data.imageItem.videoUrl}
                    loopWithSound={data.imageItem.loopWithSound}
                    poster={data.imageItem.image}
                  />
                ) : (
                  <ImageItem image={data.imageItem.image} />
                )}
              </AssetWrapper>
            )}
        <TextWrapper>
          {data.heading && <Heading size={3}>{data.heading}</Heading>}
          {data.shortText && (
            <Paragraph>
              <RichText content={data.shortText.raw} firstParMargin />
            </Paragraph>
          )}
        </TextWrapper>
      </ColWrapper>
    </Wrapper>
  );
};

export default TextImgText;
